import { render, staticRenderFns } from "./Developments.vue?vue&type=template&id=2ef06a7a&scoped=true&"
import script from "./Developments.vue?vue&type=script&lang=js&"
export * from "./Developments.vue?vue&type=script&lang=js&"
import style0 from "./Developments.vue?vue&type=style&index=0&id=2ef06a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef06a7a",
  null
  
)

export default component.exports